import styled from 'styled-components';

import { Link } from '@sorare/routing';

import type { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { DumbPlayerAvatar } from '@sorare/core/src/components/player/DumbPlayerAvatar';
import { ANY_SPORT_PLAYERS_SLUG } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

type Props = {
  displayName: string;
  squaredPictureUrl: string | null;
  slug: string;
  positions: string[];
  shirtNumber: number | null;
  activeClubName?: string;
  sport?: Sport;
};

const Root = styled.div`
  display: flex;
  gap: var(--unit);
`;
const StyledDumbPlayerAvatar = styled(DumbPlayerAvatar)`
  width: 48px;
  height: 48px;
`;

export const DumbPlayerDescription = (props: Props) => {
  const {
    displayName,
    squaredPictureUrl,
    slug,
    positions,
    shirtNumber,
    activeClubName,
    sport,
  } = props;
  const { generateSportContextPath } = useSportContext();

  return (
    <Root>
      <StyledDumbPlayerAvatar
        name={displayName}
        avatarUrl={squaredPictureUrl}
      />
      <div>
        <Link
          to={generateSportContextPath(ANY_SPORT_PLAYERS_SLUG, {
            params: { slug },
            sport,
          })}
        >
          <BodyM bold>{displayName}</BodyM>
        </Link>
        <BodyM color="var(--c-nd-600)">
          {`${positions.join(', ')} #${shirtNumber} | ${activeClubName}`}
        </BodyM>
      </div>
    </Root>
  );
};
